import React, { useState, useEffect, useMemo } from 'react';
import DataGrid from '../../../../Core/Controls/Grid/index';
import { AddButton, EditButton, BreadCrumbs } from '../../../../Core/Controls';
import DialogBox from './delayReasonDialog';
import { useToast } from '../../../../Core/Hooks/useToast';
import DialogComp from '../../../../Core//Dialog/DialogComp';
import '../../../commonStyle.scss';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';

import { getAllDelayReason, postDelayReason } from '../../../../Core/Services/InternalUser/bookingDelayReason';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Jobs', active: true },
    { name: 'Booking Delay Reasons', active: true }
];
const basecolumns = [
    { key: 'action', name: 'Action', width: '5%' },
    { key: 'bookingDateDelayReasonDescription', name: 'Description' }
];
const BookingDelayReason = () => {
    const [state, setState] = useState({
        open: false,
        showLoader: true,
        selectedRowData: {}
    });
    const { showToastSuccess, showToastError } = useToast();

    const pullApiData = async () => {
        // /let res = await getAllDelayReason();
        setState((st) => ({
            ...st,
            isReload: new Date()
        }));
    };
    const renderEdit = (ev, row) => {
        return (
            <div
                style={{
                    textAlign: 'center'
                }}
            >
                <EditButton
                    toolTipTitle="Edit Booking Delay Reason"
                    onClick={() => {
                        setState((st) => ({
                            ...st,
                            open: true,
                            title: 'Edit Booking Delay Reason',
                            selectedRowData: row,
                            isAdd: false
                        }));
                    }}
                />
            </div>
        );
    };
    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.key === 'action');
        if (actionCol) {
            actionCol.formatter = renderEdit;
        }
        return tempCols;
    }, []);

    const saveData = async (outData) => {
        let response = await postDelayReason({
            bookingDateDelayReasonID: outData.id ?? null,
            bookingDateDelayReasonDescription: outData.value
        });
        if (response) {
            response.success
                ? showToastSuccess(response.message || 'Booking Delay Reason updated successfully')
                : showToastError(response.message || 'Something went wrong');
        } else {
            showToastError('Something went wrong');
        }
        pullApiData();
    };
    const addBtnClicked = () => {
        setState((st) => ({
            ...st,
            open: true,
            title: 'Add Booking Delay Reason',
            isAdd: true,
            selectedRowData: {}
        }));
    };
    const handleClose = () => {
        setState((st) => ({
            ...st,
            open: false
        }));
    };
    return (
        <div className="screen">
            <BreadCrumbs crumbs={crumbs} />

            <GijgoGrid
                columns={columns}
                getUrl={`BookingDateDelayReasons`}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
                btnTitle="Add Booking Delay Reason"
                onBtnClick={addBtnClicked}
            />
            {state.open ? (
                <DialogComp open={state.open} onClose={handleClose} title={state.title} maxWidth="md">
                    <DialogBox data={state} onClose={handleClose} saveData={saveData} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default BookingDelayReason;
